import { render, staticRenderFns } from "./BlocchiHome.vue?vue&type=template&id=bf47358e&scoped=true"
import script from "./BlocchiHome.vue?vue&type=script&lang=js"
export * from "./BlocchiHome.vue?vue&type=script&lang=js"
import style0 from "./BlocchiHome.vue?vue&type=style&index=0&id=bf47358e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf47358e",
  null
  
)

export default component.exports